import React, { useEffect, useState } from 'react'

import { fontSize } from 'styled-system'

import { Flex } from 'app/components/design-system-components'
import { Select } from 'app/components/design-system-components/inputs/Select/Select'
import { FilterDateRange } from 'app/components/design-system-components/list-filters/FilterDateRange'
import { FilterDropdown } from 'app/components/design-system-components/list-filters/FilterDropdown'
import {
  dateRangeFiltersFields,
  getPeriodOptionValue,
  periodsOptions,
} from 'app/dashboard/team_activity/ActivityFilters/DateRangeFilter'
import { activityPeriods } from 'app/dashboard/team_activity/ActivityFilters/DateRangeFilter/constants'
import {
  buildRenderedFilterConfig,
  filtersIds,
} from 'app/features/teams/messages/table-filters/filters.config'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import { isAccountPremier } from 'app/utils/accounts/helpers'

const defaultTriggerProps = {
  mr: theme.space[3] + 'px',
  mb: theme.space[3] + 'px',
}

export const MessagesFilters = ({
  filters,
  updateFilter,
  currentTeam,
  managers,
  plan,
  pods,
  onPeriodChange,
  initialPeriod,
  includePodsFilter,
  includeFilterRelets,
  isPodsDisabled,
  ...containerProps
}) => {
  const {
    [filtersIds.manager]: managerFilterConfig,
    [filtersIds.property]: propertyFilterConfig,
    [filtersIds.propertyType]: propertyTypeFilterConfig,
    [filtersIds.enquirerActions]: enquirerActionsFilterConfig,
    [filtersIds.readStatus]: readStatusFilterConfig,
    [filtersIds.leadSource]: leadSourceFilterConfig,
    [filtersIds.pods]: podsFilterConfig,
    [filtersIds.dateRange]: dateRangeFilterConfig,
    [filtersIds.mgmtType]: mgmtTypeFilterConfig,
  } = buildRenderedFilterConfig(filters, updateFilter)

  const isLeadDisabled = !isAccountPremier(currentTeam.accountType)

  const [periodInitiator, setPeriodInitiator] = useState(
    periodsOptions.find((opt) => opt.optionMeta.id === initialPeriod),
  )

  useEffect(() => {
    onPeriodChange && onPeriodChange(periodInitiator)
    if (
      !periodInitiator ||
      periodInitiator.optionMeta.id === activityPeriods.custom
    ) {
      return
    }
    const range = getPeriodOptionValue(periodInitiator?.optionMeta.id)
    dateRangeFilterConfig.setFilterValues({
      [filtersIds.dateRange]: {
        ...{
          [dateRangeFiltersFields.start]: range.startDate,
          [dateRangeFiltersFields.end]: range.endDate,
        },
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodInitiator])

  const onDateRangeManualUpdate = (date) => {
    setPeriodInitiator(
      periodsOptions.find(
        (opt) => opt.optionMeta.id === activityPeriods.custom,
      ),
    )
  }

  return (
    <Flex flexDirection="column">
      <Flex flexWrap="wrap" mt={theme.space[3] + 'px'} {...containerProps}>
        <FilterDropdown
          filterConfig={managerFilterConfig}
          filterBodyProps={{ managers }}
          triggerCmpProps={defaultTriggerProps}
        />
        {includePodsFilter && (
          <FilterDropdown
            filterConfig={podsFilterConfig}
            filterBodyProps={{ pods, disabled: isPodsDisabled }}
            triggerCmpProps={defaultTriggerProps}
          />
        )}

        {/* hiding property filter until the confusion about functionality difference between search and filters discussed */}
        {/*<FilterDropdown*/}
        {/*  filterConfig={propertyFilterConfig}*/}
        {/*  filterBodyProps={{ teamId }}*/}
        {/*  triggerCmpProps={defaultTriggerProps}*/}
        {/*/>*/}

        <FilterDropdown
          filterConfig={propertyTypeFilterConfig}
          triggerCmpProps={defaultTriggerProps}
        />
        <FilterDropdown
          filterConfig={enquirerActionsFilterConfig}
          triggerCmpProps={defaultTriggerProps}
        />
        <FilterDropdown
          filterConfig={readStatusFilterConfig}
          triggerCmpProps={defaultTriggerProps}
        />
        <FilterDropdown
          filterConfig={leadSourceFilterConfig}
          triggerCmpProps={defaultTriggerProps}
          filterBodyProps={{ disabled: isLeadDisabled }}
          disabled={isLeadDisabled}
        />
        <Select
          options={periodsOptions}
          value={periodInitiator}
          changeHandler={(opt) => setPeriodInitiator(opt)}
          label="Select period"
          resultsLabel="PERIODS"
          width="180px"
          triggerWrapperComponentProps={{
            height: `${theme.space[8]}px`,
            fontSize: `${theme.fontSizes.pSmall12}`,
            padding: `${theme.space[3]}px ${theme.space[4]}px !important`,
          }}
          mr={4}
        />
        {includeFilterRelets && (
          <FilterDropdown
            filterConfig={mgmtTypeFilterConfig}
            triggerCmpProps={defaultTriggerProps}
          />
        )}
      </Flex>
      <Flex flexWrap="wrap" mt={theme.space[3] + 'px'} {...containerProps}>
        {periodInitiator?.optionMeta?.id === activityPeriods.custom && (
          <FilterDateRange
            onChange={onDateRangeManualUpdate}
            filterConfig={dateRangeFilterConfig}
            elementHeight="34px"
            dropDownWidth="175px"
            elementFontSize="12px"
            elementMaxWidth="150px"
            defaultStyle={false}
          />
        )}
      </Flex>
    </Flex>
  )
}
